// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  textAlign: 'left',
  paddingTop: '10px',
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'flex-start',
})

export const Message = styled('div', {
  padding: '0 10px 10px 10px',
})

export const ButtonContainer = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'flex-start',
  padding: '0 10px',
})

export const SelectContainer = styled<{}>('div', ({ $palette }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'flex-start',
  backgroundColor: `${$palette('gray').lighten(8)}`,
  padding: '10px 0',
}))
